export const SET_SITES_LIST = "SET_SITES_LIST";
export const SET_CLIENTS_LIST = "SET_CLIENTS_LIST";
export const SET_NOMENCLATURES_LIST = "SET_NOMENCLATURES_LIST";

export const SET_CLIENT = "SET_CLIENT";
export const SET_SITE = "SET_SITE";
export const SET_EXTERNAL_ID = "SET_EXTERNAL_ID";
export const SET_DESIGNATION = "SET_DESIGNATION";
export const SET_MARK = "SET_MARK";
export const SET_LAST_LEAK_DETECTION_DATE = "SET_LAST_LEAK_DETECTION_DATE";
export const SET_INTEGRATED_LEAK_DETECTOR = "SET_INTEGRATED_LEAK_DETECTOR";
export const SET_FLUID_CODE = "SET_FLUID_CODE";
export const SET_CURRENT_LOAD = "SET_CURRENT_LOAD";
export const SET_NOMINAL_LOAD = "SET_NOMINAL_LOAD";

export const ADD_COMPONENT = "ADD_COMPONENT";
export const REMOVE_COMPONENT = "REMOVE_COMPONENT";

export const SET_DEFAULT_INSTALLATION = "SET_DEFAULT_INSTALLATION";

export const smallLabelFormInputProps = {
  layout: "horizontal",
  labelClassName: "col-xl-3 text-xl-left",
  widgetClassName: "col-xl-9",
};

export const bigLabelFormInputProps = {
  layout: "horizontal",
  labelClassName: "col-xl-5 text-xl-left",
  widgetClassName: "col-xl-7",
};
